import type { QueryClient } from '@tanstack/react-query';

import { useSidebarStore } from '@/shared/components/layout/_useSidebarStore';
import { useAuthStore } from '@/shared/auth/authStore';
import { ATTENDANCE_TERMINAL_STORAGE_KEY } from '@/shared/auth/attendanceTerminal';
import { useLoadingOverlayStore } from '@/shared/store/loadingOverlayStore';
import { useModalStore } from '@/shared/store/modalStore';
import { useToastStore } from '@/shared/store/toastStore';
import { useParentStudentStore } from '@/shared/store/parentStudentStore';

let queryClientRef: QueryClient | undefined;
let axiosEphemeralReset: (() => void) | undefined;

/** 로그아웃 시 React Query 캐시까지 비우려면 앱 부트스트랩에서 QueryClient를 한 번 등록합니다. */
export function registerQueryClientForSessionPurge(client: QueryClient) {
  queryClientRef = client;
}

/** axios 인터셉터 모듈 로드 시 세션 purge에 스로틀·갱신 대기열 초기화를 연결합니다 (순환 import 방지). */
export function registerAxiosEphemeralResetForSessionPurge(reset: () => void) {
  axiosEphemeralReset = reset;
}

/** 로컬·세션 스토리지, 쿠키, 전역 Zustand·React Query 캐시·(등록된 경우) axios 인메모리 상태를 비웁니다. 라우팅은 호출 측에서 처리합니다. */
export function purgeClientSession() {
  queryClientRef?.clear();
  axiosEphemeralReset?.();

  useModalStore.getState().close();
  useToastStore.getState().hideToast();
  useLoadingOverlayStore.getState().setIsLoading(false);
  useSidebarStore.setState({
    expandedMenuKeys: [],
    isSidebarExpanded: false,
    isMobileDrawerOpen: false,
  });

  useAuthStore.getState().resetUserInfo();
  useParentStudentStore.getState().reset();

  // 출석 단말 인증키는 재조회가 불가능하므로 로그아웃·세션 만료로 지우지 않는다.
  const attendanceTerminal = window.localStorage.getItem(ATTENDANCE_TERMINAL_STORAGE_KEY);
  window.localStorage.clear();
  if (attendanceTerminal) window.localStorage.setItem(ATTENDANCE_TERMINAL_STORAGE_KEY, attendanceTerminal);
  window.sessionStorage.clear();
  document.cookie = 'refreshToken=; Path=/; Max-Age=0';
}
